export default "__VITE_ASSET__ro27T71T__"